import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Validator from 'utils/Validator';
import PropTypes from 'prop-types';
import UploadImage from '../form-input/upload-image/UploadImage';

function FormImage(props) {
    const {
        fieldName,
        validate = [],
        placeholder,
        disabled = false,
        height = '130px',
        width = '100%',
        isRegexLabel,
        validationFE = false,
        accept,
        message
    } = props;
    const {
        formState: { errors },
        control,
    } = useFormContext();

    return (
        <div style={{
            width: width ,height: height
        }} className="Input">
            <div className="w-100 h-100">
                <Controller
                    control={control}
                    name={fieldName}
                    rules={{
                        validate: Validator.genValidate(validate, fieldName),
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => {

                        return (
                            <UploadImage
                                refInput={ref}
                                name={fieldName}
                                onChange={(e) => {
                                    onChange(e);
                                }}
                                onBlur={onBlur}
                                value={value}
                                placeholder={placeholder}
                                disabled={disabled}
                                errors={errors}
                                maximumUpload={100}
                                maximumMb={100}
                                isRegexLabel={isRegexLabel}
                                validationFE={validationFE}
                                accept={accept}
                                message={message}
                            />
                        );
                    }}
                />
            </div>
        </div>
    );
}
FormImage.defaultProps = {
    placeholder: '',
    fieldName: 'fieldName',
};
FormImage.propTypes = {
    fieldName: PropTypes.string,
    validate: PropTypes.array,
    format: PropTypes.string,
    disabled: PropTypes.bool,
    iconSearch: PropTypes.element,
    width: PropTypes.string,
    height: PropTypes.string,
    background: PropTypes.string,
    isSearch: PropTypes.bool,
};
export default FormImage;
